module.exports = __webpack_public_path__ + "static/img/rebel_pictgrid31_980x870.1bafd2a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/rebel_pictgrid31_980x870.jpg
// module id = ctet
// module chunks = 0